import React from 'react';

const ServiceSchema = ({ service }) => {
  const siteUrl = window.location.origin;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${siteUrl}/services/${service.slug}#service`,
    "serviceType": service.title,
    "name": service.title,
    "url": `${siteUrl}/services/${service.slug}`,
    "description": service.description,
    "provider": {
      "@type": "Organization",
      "name": "Maverxx Innovations",
      "@id": `${siteUrl}/#organization`,
      "url": siteUrl
    },
    "areaServed": {
      "@type": "Country",
      "name": "India"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": service.title,
      "itemListElement": service.useCases.map((useCase, index) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": useCase
        }
      }))
    }
  };

  return (
    <script
      type="application/ld+json"
      data-testid={`service-schema-jsonld-${service.slug}`}
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default ServiceSchema;
